module.exports = __webpack_public_path__ + "b014cc2deab369602f5b56837d7ab15e.MP3";